export const RENTALS_PARTNERS = {
  //getPartnersSuppliers
  RENTALS_PARTNERS_SUPPLIER: 'RENTALS_PARTNERS_SUPPLIER',
  //getPartnersContractType
  RENTALS_PARTNERS_CONTRACT_TYPE: 'RENTALS_PARTNERS_CONTRACT_TYPE',
  //getPartnersOptionType
  RENTALS_PARTNERS_OPTIONS_TYPE: 'RENTALS_PARTNERS_OPTIONS_TYPE',
  //_getPartnersCooperationType
  RENTALS_PARTNERS_COOPERATION_TYPE: 'RENTALS_PARTNERS_COOPERATION_TYPE',
  //_getPartner
  RENTALS_PARTNER_INFO: 'RENTALS_PARTNER_INFO',
  //_getContractPartners
  RENTALS_PARTNERS_ALL: 'RENTALS_PARTNERS_ALL',
  //getBanks
  RENTALS_PARTNER_BANKS: 'RENTALS_PARTNER_BANKS',
  //getPartnerAccountType
  RENTALS_PARTNER_ACCOUNT_TYPE: 'RENTALS_PARTNER_ACCOUNT_TYPE',
  //getCurrenciesFromRoot
  RENTALS_PARTNER_CURRENCIES: 'RENTALS_PARTNER_CURRENCIES',
  //getPartnerBankAccount
  RENTALS_PARTNER_BANK_ACCOUNT: 'RENTALS_PARTNER_BANK_ACCOUNT',
  //getPartnerContactsAccounts
  RENTALS_PARTNER_CONTACTS_ACCOUNTS: 'RENTALS_PARTNER_CONTACTS_ACCOUNTS',
};
